import {modules} from "@/systems/modules/modules.js";
import PlaytimeView from "@/systems/modules/analytics/PlaytimeView.vue";
import PlayerSessionsView from "@/systems/modules/analytics/PlayerSessionsView.vue";
import StatisticsView from "@/systems/modules/analytics/StatisticsView.vue";
import authorization from "@/authorization";
import AnalyticsHeaderView from "@/systems/modules/analytics/AnalyticsHeaderView.vue";
import AnalyticsPlayerHeaderView from "@/systems/modules/analytics/AnalyticsPlayerHeaderView.vue";

export default {
    getRoutes: () => ([
        {
            name: "community.modules.analytics",
            path: "analytics",
            component: AnalyticsHeaderView,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.analytics) && (authorization.permission("modules.analytics.playtime.view") || authorization.permission("modules.analytics.sessions.view") || authorization.permission("modules.analytics.statistics.view")),
            },
            redirect: { name: "community.modules.analytics.playtime" },
            children: [
                {
                    name: "community.modules.analytics.playtime",
                    path: "playtime",
                    component: PlaytimeView,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("modules.analytics.playtime.view"),
                    },
                },
                {
                    name: "community.modules.analytics.sessions",
                    path: "sessions",
                    component: PlayerSessionsView,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("modules.analytics.sessions.view"),
                    },
                },
                {
                    name: "community.modules.analytics.statistics",
                    path: "statistics",
                    component: StatisticsView,
                    props: true,
                    meta: {
                        authorize: () => authorization.permission("modules.analytics.statistics.view"),
                    },
                }
            ]
        },
    ]),
    getPlayerRoutes: () => ([
        {
            name: "player.modules.analytics",
            path: "analytics",
            component: AnalyticsPlayerHeaderView,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.analytics) && (authorization.permission("modules.analytics.playtime.view") || authorization.permission("modules.analytics.sessions.view")),
            },
            redirect: { name: "player.modules.analytics.playtime" },
            children: [
                {
                    name: "player.modules.analytics.playtime",
                    path: "playtime",
                    component: PlaytimeView,
                    props: true
                },
                {
                    name: "player.modules.analytics.sessions",
                    path: "sessions",
                    component: PlayerSessionsView,
                    props: true
                }
            ]
        },
    ])
};